import React, { useEffect, useState } from 'react';
import allImgPaths from 'assets/images';
import HistoryContent from './HistoryContent';
import HistoryMain from './HistoryMain';
import { ACTION_TYPES } from 'utils/constant';
import ContentDraft from './ContentDraft';
import FeteManagement from './FeteManagement';
import CardsAndBlocks from './CardsAndBlocks';
import TaskManagement from './TaskManagement';
import UserManagement from './UserManagement';
import Selection from './Selection';
import FileManagement from './FileManagement';

interface HistorySectionProps {
    data?: any[],
    period?: string;
    showDate?: Boolean;
    activityIcon?: any;
    date: any;
}

const HistoryTimesLab = ({ data, period, showDate, activityIcon, date }: HistorySectionProps) => {
    const [historyData, setHistoryData] = useState<any[]>(data || [])

    useEffect(() => {
        if (data?.length) {
            const updatedData = data.map((item, index) => ({
                ...item,
                showLine: index < data.length - 1 && item['action_type'] !== data[index + 1]['action_type']
            }));

            setHistoryData(updatedData)
        }
    }, [])

    return (
        <>
            <>
                <div className="w-full flex items-center justify-between border-b border-[#D0D5DD] pb-2 mb-4">
                    <span className="text-xs text-[#667085]">{period}</span>
                    {showDate && <span className="text-xs text-[#667085]">{date}</span>}
                </div>
                {
                    historyData.map((dt: any, index: number) => (
                        <div className="" key={index}>
                            {
                                dt.action_type == ACTION_TYPES.CONTENT_DRAFTING &&
                                <>
                                    <ContentDraft data={dt} period={period}/>
                                    {
                                        dt?.showLine &&
                                        <div className="w-full flex items-center justify-between border-[#D0D5DD]"></div>
                                    }
                                </>
                            }
                            {
                                dt.action_type == ACTION_TYPES.SELECTION &&
                                <>
                                    <Selection data={dt} period={period} />
                                    {
                                        dt?.showLine &&
                                        <div className="w-full flex items-center justify-between border-[#D0D5DD]"></div>
                                    }
                                </>
                            }
                            {
                                dt.action_type == ACTION_TYPES.CARDS_AND_BLOCKS &&
                                <>
                                    <CardsAndBlocks data={dt} period={period} />
                                    {
                                        dt?.showLine &&
                                        <div className="w-full flex items-center justify-between border-[#D0D5DD]"></div>
                                    }
                                </>
                            }
                            {
                                dt.action_type == ACTION_TYPES.TASK_MANAGEMENT &&
                                <>
                                    <TaskManagement data={dt} period={period} />
                                    {
                                        dt?.showLine &&
                                        <div className="w-full flex items-center justify-between border-[#D0D5DD]"></div>
                                    }
                                </>
                            }
                            {
                                dt.action_type == ACTION_TYPES.FILE_MANAGEMENT &&
                                <>
                                    <FileManagement data={dt} period={period} />
                                    {
                                        dt?.showLine &&
                                        <div className="w-full flex items-center justify-between border-[#D0D5DD]"></div>
                                    }
                                </>
                            }
                            {
                                dt.action_type == ACTION_TYPES.FETE_MANAGEMENT &&
                                <>
                                    <FeteManagement data={dt} period={period} />
                                    {
                                        dt?.showLine &&
                                        <div className="w-full flex items-center justify-between border-[#D0D5DD]"></div>
                                    }
                                </>
                            }
                            {
                                dt.action_type == ACTION_TYPES.USER_MANAGEMENT &&
                                <>
                                    <UserManagement data={dt} period={period} />
                                    {
                                        dt?.showLine &&
                                        <div className="w-full flex items-center justify-between border-[#D0D5DD]"></div>
                                    }
                                </>
                            }
                        </div>
                    ))
                }
            </>

        </>
    )
}

export default HistoryTimesLab